import { render, staticRenderFns } from "./UserMedia.vue?vue&type=template&id=19ce7b23&"
import script from "./UserMedia.vue?vue&type=script&lang=js&"
export * from "./UserMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports